import Vue from 'vue'
import Router from 'vue-router'
// 主页
import Home from '@/pages/home/index.vue'
// 便民查询
import Bmquery from '@/pages/bmquery/index.vue'
// 交通事件
import eventMsg from '@/pages/eventmsg/index.vue'
import dlyh from '@/pages/eventmsg/dlyh.vue'
import jtsg from '@/pages/eventmsg/jtsg.vue'
import tstq from '@/pages/eventmsg/tstq.vue'
import bus from '@/pages/bus/index.vue'
// 交通新闻
import transNews from '@/pages/transNews/index.vue'
import cxts from '@/pages/transNews/cxts.vue'
import hygg from '@/pages/transNews/hygg.vue'
import xwdt from '@/pages/transNews/xwdt.vue'
// 投诉咨询服务
import tszxSevers from '@/pages/tszxsevers/index.vue'
import complaintsReport from '@/pages/tszxsevers/complaintsReport.vue'
import msgTrackingAndQuery from '@/pages/tszxsevers/msgTrackingAndQuery.vue'
import statistics_month from '@/pages/tszxsevers/statistics_month.vue'
// 交通证件查询
import jtzjQuery from '@/pages/jtzjquery/index.vue'
import credentialsQuery1 from '@/pages/jtzjquery/credentialsQuery1.vue'
import credentialsQuery2 from '@/pages/jtzjquery/credentialsQuery2.vue'
// 行业监督信息
import hyjdMsg from '@/pages/hyjdmsg/index.vue'
import pipedepartment from '@/pages/hyjdmsg/pipedepartment.vue'
import roaddepartment from '@/pages/hyjdmsg/roaddepartment.vue'
import maritimrdepartment from '@/pages/hyjdmsg/maritimrdepartment.vue'
import taxiTraffic from '@/pages/hyjdmsg/taxiTraffic.vue'
import busTraffic from '@/pages/hyjdmsg/busTraffic.vue'
import dangerTraffic from '@/pages/hyjdmsg/dangerTraffic.vue'
import normalTraffic from '@/pages/hyjdmsg/normalTraffic.vue'

//在线查询
import queryOnline from '@/pages/queryOnline/index.vue'
//重定向页面
import redirect from '@/pages/redirect.vue'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [{
      path: '/',
      redirect: '/Home'
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home,
    },
    {
      path: '/redirect',
      name: 'redirect',
      component: redirect,
    },
    {
      // 交通新闻
      path: '/transNews',
      name: 'transNews',
      component: transNews,
      //redirect: '/transNews/cxts',
      children: [{
          path: '/transNews/cxts',
          name:"cxts",
          component: cxts
        },
        {
          path: '/transNews/xwdt',
          component: xwdt
        },
        {
          path: '/transNews/hygg',
          name:"hygg",
          component: hygg
        },
      ]
    },
    {
      // 交通事件
      path: '/eventMsg',
      name: 'eventMsg',
      component: eventMsg,
      // redirect: '/eventMsg/tstq',
      children: [{
          path: '/eventMsg/dlyh',
          name:"dlyh",
          component: dlyh
        },
        {
          path: '/eventMsg/jtsg',
          name:"jtsg",
          component: jtsg
        },
        {
          path: '/eventMsg/tstq',
          name:"tstq",
          component: tstq
        },
      ]
    },
    {
      // 公交出行
      path: '/bus',
      name: 'bus',
      component: bus,
    },
    {
      // 行业监督信息
      path: '/hyjdMsg',
      name: 'hyjdMsg',
      component: hyjdMsg,
      redirect:"/hyjdMsg/taxiTraffic",
      children: [
        {
          path: '/hyjdMsg/pipedepartment',
          component: pipedepartment
        },
        {
          path: '/hyjdMsg/roaddepartment',
          component: roaddepartment
        },
        {
          path: '/hyjdMsg/maritimrdepartment',
          component: maritimrdepartment
        },
        {
          path: '/hyjdMsg/taxiTraffic',
          component: taxiTraffic
        },
        {
          path: '/hyjdMsg/busTraffic',
          component: busTraffic
        },
        {
          path: '/hyjdMsg/dangerTraffic',
          component: dangerTraffic
        },
        {
          path: '/hyjdMsg/normalTraffic',
          component: normalTraffic
        }
      ]
    },
    {
      // 投诉咨询服务
      path: '/tszxSevers',
      name: 'tszxSevers',
      component: tszxSevers,
      //redirect: '/tszxSevers/complaintsReport',
      children: [{
          path: '/tszxSevers/complaintsReport',
          component: complaintsReport
        },
        {
          path: '/tszxSevers/msgTrackingAndQuery',
          component: msgTrackingAndQuery
        },
        {
          path: '/tszxSevers/statistics_month',
          component: statistics_month
        }
      ]
    },
    {
      // 交通证件查询
      path: '/jtzjQuery',
      name: 'jtzjQuery',
      component: jtzjQuery,
      //redirect: '/jtzjQuery/credentialsquery1',
      children: [{
          path: '/jtzjQuery/credentialsquery1',
          component: credentialsQuery1
        },
        {
          path: '/jtzjQuery/credentialsquery2',
          component: credentialsQuery2
        },
      ]
    },
    {
      path: '/bmquery',
      name: 'Bmquery',
      component: Bmquery
    },
    {
      path: '/queryOnline',
      name: 'queryOnline',
      component: queryOnline
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js


// WEBPACK FOOTER //
// ./src/router/index.js